module.exports = __webpack_public_path__ + "static/img/18.53e78809.jpg";